import {GetCookieInfo} from "./CookieManager";
import {GetClientBundle} from "./DataProvider";

export const UpdateTicketStatus = async (ticketId, newStatus) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_TICKETING_URL}/status`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    ticketId: ticketId,
                    newStatus: newStatus
                })
            }
        );
        if (response.ok) {
            const data = await response.json();
            return data.success;
        } else {
            console.log('Fetch ticket failed.');
            return false;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return false;
    }
};

export const CreateDataUpdateTicket = async (subtype, meta) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_TICKETING_URL}/ticket-data-update`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    type: 9,
                    subtype: subtype,
                    meta : JSON.stringify(meta)
                })
            }
        );
        if (response.ok) {
            const data = await response.json();
            let bundle = GetClientBundle();
            if (bundle.tickets) {
                bundle.tickets.push(data.data);
                SortTickets(bundle.tickets);
            } else {
                bundle.tickets = [data.data];
            }
            return data.success;
        } else {
            console.log('Create ticket failed.');
            return false;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return false;
    }
};
export const SortTickets = (tickets) => {
    tickets.sort((a, b) => {
        const dateA = new Date(a.lastActivityDate);
        const dateB = new Date(b.lastActivityDate);
        return dateB - dateA;
    });
}